<template>
  <div class="container">
    <navTop class="navTop" :topIndex="topIndex" />
    <carousel />
    <product />
    <solution />
    <brand />
    <footer-a />
    <back-top />
  </div>
</template>

<script>
import carousel from '../components/carousel'
import product from '../components/home/product'
import navTop from '../components/nav'
import brand from '../components/brand'
import solution from '../components/home/solution'
import footerA from '../components/footer'
import backTop from '../components/backTop'
export default {
  data () {
    return {
      topIndex: 0
    }
  },
  components: {
    carousel,
    navTop,
    brand,
    solution,
    product,
    backTop,
    footerA
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/index.vue